/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Foot_RankingInputs */

const en_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ranking ${i?.count} endpoints by relevance`)
};

const zh_hans1_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在按相关度为 ${i?.count} 个接口排序`)
};

const pt_br2_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordenando ${i?.count} endpoints por relevância`)
};

const es_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordenando ${i?.count} endpoints por relevancia`)
};

const fr_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Classement de ${i?.count} endpoints par pertinence`)
};

const de_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Endpoints werden nach Relevanz sortiert`)
};

const ru_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ранжируем эндпоинты по релевантности: ${i?.count}`)
};

const it_search_foot_ranking = /** @type {(inputs: Search_Foot_RankingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordinamento di ${i?.count} endpoint per rilevanza`)
};

/**
* | output |
* | --- |
* | "Ranking {count} endpoints by relevance" |
*
* @param {Search_Foot_RankingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_foot_ranking = /** @type {((inputs: Search_Foot_RankingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Foot_RankingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_foot_ranking(inputs)
	if (locale === "pt-BR") return pt_br2_search_foot_ranking(inputs)
	if (locale === "es") return es_search_foot_ranking(inputs)
	if (locale === "fr") return fr_search_foot_ranking(inputs)
	if (locale === "de") return de_search_foot_ranking(inputs)
	if (locale === "ru") return ru_search_foot_ranking(inputs)
	if (locale === "it") return it_search_foot_ranking(inputs)
	return en_search_foot_ranking(inputs)
});